export async function responseJson(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || `Request failed (${response.status})`);
  }
  return data;
}

export async function tradeGet(url) {
  return responseJson(await fetch(url));
}

export async function tradeJson(url, method, data) {
  return responseJson(await fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: data === undefined ? undefined : JSON.stringify(data),
  }));
}

export async function tradeUpload(url, formData) {
  return responseJson(await fetch(url, { method: "POST", body: formData }));
}

export function saveSession(data) {
  localStorage.setItem("token", data.access_token);
  localStorage.setItem("userRole", data.roles || "");
  localStorage.setItem("userEmail", data.email || "");
  localStorage.setItem("userId", data.userId || "");
  localStorage.setItem("userName", data.name || "");
  localStorage.setItem("allowedProjects", JSON.stringify(data.allowedProjects || []));
  localStorage.setItem("usesDefaultPassword", String(Boolean(data.usesDefaultPassword)));
}

export function clearSession() {
  [
    "token", "userRole", "userEmail", "userId", "userName",
    "allowedProjects", "usesDefaultPassword", "selectedTradeProject",
  ].forEach((key) => localStorage.removeItem(key));
}

export function formatDate(value, includeTime = false) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric", month: "short", day: "2-digit",
    ...(includeTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

export function bytesLabel(value) {
  const bytes = Number(value || 0);
  if (!bytes) return "—";
  if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
